const miniApp = {
    platform: '',
    miniappName: '',
    miniappId: '',
    username: '',
}

export default miniApp;